import { useState, useEffect } from 'react';
import { Manager } from 'socket.io-client';

const url =
  process.env.NODE_ENV === 'production'
    ? 'https://core.btm.test.hsjb.ir'
    : 'http://127.0.0.1:8000';

const manager = new Manager(url);

const App = () => {
  const [token, setToken] = useState<string>(
    localStorage.getItem('token') || ''
  );
  const [isConnected, setIsConnected] = useState(false);
  const [lastPong, setLastPong] = useState<string>('');
  const [input, setInput] = useState<string>('');
  const [pose, setPose] = useState<GeolocationCoordinates>();

  const socket = manager.socket('/client', {
    auth: {
      token,
    },
  });

  useEffect(() => {
    console.log('start');
    navigator.geolocation.watchPosition(
      (position) => {
        try {
          socket.emit(
            'location',
            JSON.stringify({
              timestamp: position.timestamp,
              accuracy: position.coords.accuracy,
              latitude: Math.floor(position.coords.latitude * 1e7),
              longitude: Math.floor(position.coords.longitude * 1e7),
              altitude: position.coords.altitude,
              heading: position.coords.heading,
              speed: position.coords.speed,
            })
          );
          setPose(position.coords);
        } catch (e) {
          console.log(e);
        }
      },
      (error) => console.log(error.code + ' ' + error.message),
      { enableHighAccuracy: true }
    );

    socket.on('connect', () => {
      setIsConnected(true);
      socket.emit('ping');
    });

    socket.on('disconnect', () => {
      setIsConnected(false);
    });

    socket.on('pong', () => {
      setLastPong(new Date().toISOString());
    });

    return () => {
      socket.off('connect');
      socket.off('disconnect');
      socket.off('pong');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendPing = () => {
    socket.emit('ping');
  };

  return (
    <div>
      <p>
        <input onChange={(e) => setInput(e.target.value)} type={'text'} />
        <button
          onClick={() => {
            setToken(input);
            localStorage.setItem('token', input);
          }}
        >
          save
        </button>
      </p>

      <p>server: {url}</p>
      <p>User ID: {token}</p>
      <p>Connected: {'' + isConnected}</p>
      <p>Last pong: {lastPong || '-'}</p>
      <button onClick={sendPing}>ping</button>
      <p>latitude: {pose?.latitude || '-'}</p>
      <p>longitude: {pose?.longitude || '-'}</p>
    </div>
  );
};
export default App;
